import { AxiosError } from 'axios'
import {
  PromiseAction,
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { put, takeEvery } from 'redux-saga/effects'
import { FormTypes } from '@/types'
import { AuthAdminDTO } from '../../api/dto'
import { authData } from '../data/slice'
import { AUTH_ADMIN_FAILED, AUTH_ADMIN_REQUEST, AUTH_ADMIN_SUCCESS } from './actionTypes'

export const authAdminPA = createPromiseAction(
  AUTH_ADMIN_REQUEST,
  AUTH_ADMIN_SUCCESS,
  AUTH_ADMIN_FAILED
)<AuthAdminDTO, unknown, AxiosError<FormTypes.ValidationErrors>>()

function* auth(action?: PromiseAction<string, AuthAdminDTO, any>) {
  try {
    if (action) {
      const { payload } = action

      //console.log('on authadmin set token: ' + payload.token)
      // If the payload has a token, use it for authentication
      yield put(authAdminPA.success({}))
      yield put(authData.setFrameAdminToken({ frameAdminToken: payload.token }))
      resolvePromiseAction(action, {})
    }
  } catch (err: any) {
    if (!err.response) {
      throw err
    }
    if (action) rejectPromiseAction(action, err.response.data)
  }
}

export function* authAdminSaga() {
  yield takeEvery(authAdminPA.request, auth)
}
